import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { TableRow } from "../Editable/TableRow";

export const DraggableTableRow = (props: any) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id: props["data-row-key"],
        data: {
            record: props.record,
        },
    });

    const style: React.CSSProperties = {
        ...props.style,
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: "move",
    };

    return <TableRow {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
};
